import React from 'react'
import { connect } from 'react-redux'
import 'moment/locale/pt-br'
import '../../../css/components/react-datepicker.css';
import Autorizacao from '../../../security/Autorizacao';
import {
  getAdminEmpresa,
  getFinanceiroAgencia, getFinanceiroCaixa,
  getGestorEmpresa,
  getOperadorEmpresa,
  PERFIL_ADMIN,
} from '../../../security/securityContext';
import AcoesFechamentoCaixa from '../AcoesFechamentoCaixa';


export class FechamentoCaixaAgencia extends React.Component {
  render () {
    const { fechamento, isFechamentoDia } = this.props;
    return (
      <div className="vx-gp-row" style={{ borderLeft: isFechamentoDia ? '4px solid #f59e0b' : undefined }}>
        <div className="vx-gp-row-main vx-gp-row-main--fechamento-agencia">
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Data</span>
            <span className="vx-gp-field-value">{fechamento.dataFechamento}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Agência</span>
            <span className="vx-gp-field-value">{fechamento.nomeAgencia}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Qtd. Vendas</span>
            <span className="vx-gp-field-value">{fechamento.quantidadeVendas}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Valor Total</span>
            <span className="vx-gp-field-value" style={{ fontWeight: 600 }}>
              R$ {fechamento.totais.totalVendas}
            </span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Situação</span>
            <span className="vx-gp-field-value">{fechamento.descricaoSituacao}</span>
          </div>
          <div className="vx-gp-field">
            <Autorizacao
              perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id)
              ]}>
              <AcoesFechamentoCaixa seAgencia={true} item={fechamento} paginaDetalhamento='detalhe-fechamento-agencia'/>
            </Autorizacao>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '24px', padding: '6px 16px 8px', fontSize: '12px', color: '#555', borderTop: '1px solid #f0f0f0' }}>
          <span><strong>Comissão:</strong> R$ {fechamento.totais.totalComissao}</span>
          <span><strong>Depósito:</strong> R$ {fechamento.totais.totalDeposito}</span>
          {isFechamentoDia && <span style={{ color: '#d97706', fontWeight: 700 }}>⬤ Fechamento do Dia</span>}
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    empresaSelecionada: state.empresaSelecionada
  });

export default connect(mapStateToProps, {})(FechamentoCaixaAgencia)
